import { IpaType } from "../phonemes/ipa";

/** Lushootseed alphabet & sample words using those letters */
export const sampleLushootseed: LSLetter[] = [
  {
    letter: "ʔ", ipa: "ʔ", samples: [
      { word: "ʔalʔal", meaning: "house" },
      { word: "ʔitut", meaning: "sleep" },
    ]
  },
  {
    letter: "a", ipa: "ɑ", samples: [
      { word: "ʔaciɬtalbixʷ", meaning: "people" },
      { word: "ʔalʔal", meaning: "house" },
    ]
  },
  {
    letter: "b", ipa: "b", samples: [
      { word: "biʔbədaʔ", meaning: "baby" },
      { word: "buus", meaning: "four" },
    ]
  },
  {
    letter: "c", ipa: "t͡s", samples: [
      { word: "ʔucut", meaning: "say something" },
      { word: "sqigʷəc", meaning: "deer" },
    ]
  },
  {
    letter: "c̓", ipa: "t͡sʼ", samples: [
      { word: "c̓ip̓lil", meaning: "close your eyes" },
      { word: "c̓ubc̓ub", meaning: "barnacle" },
      { word: "c̓uʔkʷs", meaning: "seven" },
    ]
  },
  {
    letter: "č", ipa: "t͡ʃ", samples: [
      { word: "čəxʷ", meaning: "you" },
      { word: "čəxʷəluʔ", meaning: "whale" },
    ]
  },
  {
    letter: "č̓", ipa: "t͡ʃʼ", samples: [
      { word: "č̓aləs", meaning: "bracken fern" },
      { word: "č̓it", meaning: "near" },
      { word: "gʷəč̓əd", meaning: "search for" },
    ]
  },
  {
    letter: "d", ipa: "d", samples: [
      { word: "day̓ay̓", meaning: "alone" },
      { word: "sduhubš", meaning: "Snohomish" },
    ]
  },
  {
    letter: "dᶻ", ipa: "d͡z", samples: [
      { word: "dᶻədis", meaning: "tooth" },
      { word: "sq̓ədᶻuʔ", meaning: "hair" },
    ]
  },
  {
    letter: "ə", ipa: "ə", samples: [
      { word: "ʔəɬəd", meaning: "eat" },
    ]
  },
  {
    letter: "g", ipa: "ɡ", samples: [
      { word: "gəduʔ", meaning: "no good so and so" },
      { word: "gədgəd", meaning: "tickle" },
    ]
  },
  {
    letter: "gʷ", ipa: "ɡʷ", samples: [
      { word: "gʷədil", meaning: "sit" },
      { word: "gʷəč̓əd", meaning: "search for" },
    ]
  },
  {
    letter: "h", ipa: "h", samples: [
      { word: "hud", meaning: "fire" },
      { word: "hədʔiw̓", meaning: "come in" },
    ]
  },
  {
    letter: "i", ipa: "i~e", samples: [
      { word: "ʔi", meaning: "yes" },
      { word: "ʔiišəd", meaning: "feet" },
    ]
  },
  {
    letter: "ǰ", ipa: "d͡ʒ", samples: [
      { word: "ǰəsəd", meaning: "foot" },
      { word: "ǰuʔcut", meaning: "to tell a joke" },
    ]
  },
  {
    letter: "k", ipa: "k", samples: [
      { word: "kəpu", meaning: "coat" },
      { word: "kəlapx̌ʷəlč", meaning: "jellyfish" },
    ]
  },
  {
    letter: "k̓", ipa: "kʼ", samples: [
      { word: "k̓ədayuʔ", meaning: "rat" },
      { word: "k̓aʔk̓aʔ", meaning: "crow" },
      { word: "k̓əwdxʷ", meaning: "bump into" },
    ]
  },
  {
    letter: "kʷ", ipa: "kʷ", samples: [
      { word: "kʷədad", meaning: "pick up" },
      { word: "kʷatač", meaning: "climb" },
    ]
  },
  {
    letter: "k̓ʷ", ipa: "kʼʷ", samples: [
      { word: "k̓ʷəčəldiʔ", meaning: "rabbit" },
      { word: "k̓ʷat̕ad", meaning: "mouse" },
      { word: "k̓ʷid", meaning: "how many" },
    ]
  },
  {
    letter: "l", ipa: "l", samples: [
      { word: "ʔuluɬ", meaning: "travel by water" },
      { word: "lil", meaning: "far" },
    ]
  },
  {
    letter: "l̓", ipa: "lʼ", samples: [
      { word: "stəbtabəl̕", meaning: "brown bear or grizzly" },
      { word: "tətupəl̕", meaning: "spider" },
      { word: "q̓il̕bid", meaning: "canoe" },
    ]
  },
  {
    letter: "ɬ", ipa: "ɬ", samples: [
      { word: "ɬixʷ", meaning: "three" },
      { word: "ʔuluɬ", meaning: "travel by water" },
      { word: "ʔəɬəd", meaning: "eat" },
    ]
  },
  {
    letter: "ƛ̕", ipa: "t͜ɬʼ", samples: [
      { word: "ƛ̕aƛ̕ac̓apəd", meaning: "ant" },
      { word: "ʔəsƛ̕ubil", meaning: "be in good health" },
      { word: "luƛ̕", meaning: "elder" },
    ]
  },
  {
    letter: "m", ipa: "m", samples: [
      { word: "mam̓ad", meaning: "a lot of little" },
      { word: "miʔman̓", meaning: "small" },
    ]
  },
  {
    letter: "m̓", ipa: "mʼ", samples: [
      { word: "mam̓ad", meaning: "a lot of a little" },
    ]
  },
  {
    letter: "n̓", ipa: "nʼ", samples: [
      { word: "miʔman̓", meaning: "small" },
    ]
  },
  {
    letter: "p", ipa: "p", samples: [
      { word: "pədt̕əs", meaning: "winter" },
      { word: "puʔtəd", meaning: "shirt" },
    ]
  },
  {
    letter: "p̓", ipa: "pʼ", samples: [
      { word: "p̓aʔcut", meaning: "try" },
      { word: "p̓uay̓", meaning: "flounder" },
      { word: "p̓əč̓əb", meaning: "bobcat" },
    ]
  },
  {
    letter: "q", ipa: "q", samples: [
      { word: "qədxʷ", meaning: "mouth" },
      { word: "qal̕qaləx̌ʷič", meaning: "orca" },
      { word: "qah", meaning: "a lot" },
    ]
  },
  {
    letter: "q̓", ipa: "qʼ", samples: [
      { word: "bəq̓əd", meaning: "swallow something" },
      { word: "q̓ilagʷil", meaning: "get into a canoe" },
      { word: "q̓il̕bid", meaning: "canoe" },
    ]
  },
  {
    letter: "qʷ", ipa: "qʷ", samples: [
      { word: "buʔqʷ", meaning: "duck" },
      { word: "qʷəɬayʔ", meaning: "stick" },
      { word: "qʷuʔ", meaning: "water" },
    ]
  },
  {
    letter: "q̓ʷ", ipa: "qʼʷ", samples: [
      { word: "q̓ʷuʔ", meaning: "gather" },
      { word: "q̓ʷəladiʔ", meaning: "ear" },
      { word: "sq̓ʷəlaɬəd", meaning: "bear" },
    ]
  },
  {
    letter: "s", ipa: "s", samples: [
      { word: "sduhubš", meaning: "Snohomish" },
      { word: "saliʔ", meaning: "two" },
    ]
  },
  {
    letter: "š", ipa: "ʃ", samples: [
      { word: "ʔibəš", meaning: "walk" },
      { word: "st̕əx̌ʷšəd", meaning: "cedar root" },
    ]
  },
  {
    letter: "t", ipa: "t", samples: [
      { word: "tətupəl̕", meaning: "spider" },
      { word: "təlawil", meaning: "run" },
    ]
  },
  {
    letter: "t̓", ipa: "tʼ", samples: [
      { word: "t̕it̕əb", meaning: "bathe" },
      { word: "t̕ilib", meaning: "sing" },
      { word: "t̕ukʷ", meaning: "go home" },
    ]
  },
  {
    letter: "u", ipa: "u~o", samples: [
      { word: "buʔqʷ", meaning: "duck" },
      { word: "ʔucut", meaning: "say something" },
    ]
  },
  {
    letter: "w", ipa: "w~ʋ", samples: [
      { word: "waq̓waq̓", meaning: "frog" },
      { word: "təlawil", meaning: "run" },
    ]
  },
  {
    letter: "w̓", ipa: "wʼ", samples: [
      { word: "wiw̓suʔ", meaning: "children" },
      { word: "ɬaw̓t", meaning: "new" },
      { word: "qaw̓qs", meaning: "raven" },
    ]
  },
  {
    letter: "xʷ", ipa: "xʷ", samples: [
      { word: "xʷiʔ", meaning: "no" },
      { word: "sčətxʷəd", meaning: "black bear" },
      { word: "čəxʷ", meaning: "you" },
    ]
  },
  {
    letter: "x̌", ipa: "χ", samples: [
      { word: "x̌ədəd", meaning: "shove" },
      { word: "x̌alad", meaning: "write" },
    ]
  },
  {
    letter: "x̌ʷ", ipa: "χʷ", samples: [
      { word: "tux̌ʷ", meaning: "merely/just" },
      { word: "x̌ʷəl", meaning: "nine" },
      { word: "x̌ʷul̕", meaning: "just/only" },
    ]
  },
  {
    letter: "y", ipa: "j", samples: [
      { word: "yayus", meaning: "work" },
      { word: "huyəxʷ", meaning: "finished" },
    ]
  },
  {
    letter: "y̓", ipa: "jʼ", samples: [
      { word: "day̓ay̓", meaning: "alone" },
      { word: "p̓uay̓", meaning: "flounder" },
      { word: "day̓", meaning: "very" },
    ]
  },
];

export interface LSLetter {
  readonly letter: string;
  readonly ipa: IpaType;
  readonly samples: LSWord[];
}

export interface LSWord {
  readonly word: string;
  readonly meaning: string;
}
